import React, {Component} from 'react';
import {Pie, PieChart, Cell, Legend, ResponsiveContainer, Tooltip} from 'recharts'

class PortfolioAccountClasificationGraph extends Component{

  constructor(props){
    super(props);
    this.state={data:[]}
  }

  render(){

    const colors = [
      '#222',
      '#777',
      '#c79b6e'
    ]

    return(
      <ResponsiveContainer>
        <PieChart width={250} height={250} >
          <Tooltip/>
          <Legend/>
          <Pie data={this.props.data} dataKey={"quantity"} nameKey={"type"} innerRadius={50} outherRadius={55} fill={"#777"} label>
            {
              this.props.data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]}/>
              ))
            }
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }

}

export default PortfolioAccountClasificationGraph;



// WEBPACK FOOTER //
// ./src/charts/portfolioAccountClasificationGraph.js